<car-details *ngIf="openCarDetails && isVisibleDetails"></car-details>
<engineer-details *ngIf="openEngineerDetails && isVisibleDetails"></engineer-details>
<service-details *ngIf="openServiceDetails && isVisibleDetails"></service-details>
<prospect-location-details *ngIf="openProspectDetails && isVisibleDetails"></prospect-location-details>
<generic-location-details *ngIf="openGenericDetails && isVisibleDetails"></generic-location-details>
<generic-virtual-location-details *ngIf="openGenericVirtualDetails && isVisibleDetails"></generic-virtual-location-details>
<!-- eskeleton loader -->
<details-skeleton-loader *ngIf="isLoading"></details-skeleton-loader>